import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowForward } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";
import { TbArrowsSort } from "react-icons/tb";
import { HiDotsVertical } from "react-icons/hi";
import { FaArrowLeftLong } from "react-icons/fa6";

import { FaFacebook } from "react-icons/fa";

/**
 * WhatsApp Embedded Signup Redirection Flow
 * Since Facebook does not allow embedding its OAuth flow in an iframe (X-Frame-Options: deny),
 * we need to open the WhatsApp signup link in a new tab/window.
 */
function WhatsappEmbeddedSignupModal({ onClose }) {
    // You need to replace this with your real app id and redirect URI.
    const APP_ID = "617614283917585"; // get from Facebook Developer Console
    const REDIRECT_URI = "https://wa-api.globebot.io/auth/onboard/redirect"; // <--- implement this redirect URI!
    // WhatsApp embedded signup URL (documented at https://developers.facebook.com/docs/whatsapp/cloud-api/guides/embedded-signup)
    // Read WhatsApp Platform docs for details: https://developers.facebook.com/docs/whatsapp/cloud-api/guides/embedded-signup

    // helper: on button click, open popup and close modal.
    const handleOpenSignup = () => {
        const signupUrl = `https://www.facebook.com/v18.0/dialog/oauth?client_id=${APP_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&response_type=code&scope=whatsapp_business_management,whatsapp_business_messaging,business_management,public_profile,email`;
        window.open(signupUrl, "_blank", "popup,width=800,height=900");
        onClose();
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
            <div className="bg-white rounded-lg p-4 w-full max-w-[400px] relative shadow-lg">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-gray-600 hover:text-red-500 font-bold text-lg"
                    aria-label="Close"
                >×</button>
                <h3 className="text-lg font-bold mb-3 flex items-center gap-2">
                    <FaWhatsapp className="text-green-500" />
                    WhatsApp Business Signup
                </h3>
                <div className="mb-5 text-gray-700 text-sm">
                  Click below to sign up or onboard your WhatsApp Business Account via Facebook’s official embedded signup. <br />
                  <span className="text-xs text-gray-500 font-bold">
                    (You will be redirected to Facebook in a new tab)
                  </span>
                </div>
                <button
                  className="w-full flex items-center justify-center gap-2 bg-[#31b07b] text-white py-2 px-4 rounded font-semibold hover:bg-[#269869] text-sm"
                  onClick={handleOpenSignup}
                >
                  <FaWhatsapp />
                  Continue with WhatsApp Signup
                </button>
            </div>
        </div>
    );
}

function Test() {
    const data = [
        "919216058712",
        "942777555594200",
        "4287988451424117",
        "2000 (TIER_2K)",
        "HIGH | EXPIRED",
        "Set Default",
        "Aadvik Tech Services Private Limited",
        "02 Feb 2026 03:14:32 PM",
        "NA"
    ];

    const [open, setopen] = useState(false);
    const [embedSignup, setEmbedSignup] = useState(false);
    const [CompanyWebsiteName, setCompanyWebsiteName] = useState('');
    const [CompanyName, setCompanyName] = useState('');

    return (
        <>
            <div className='px-2 dark:bg-[#121519] h-[100vh] pl-4'>
                <div className='border-b-[1px] border-[#cfcdcd] pb-1 '>
                    <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff] flex items-center'>
                        <Link to='/configuration'><FaArrowLeftLong /></Link> WABAChannels
                    </h1>
                    <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>
                        <span>Home</span> <IoIosArrowForward /><span>Configuration</span><IoIosArrowForward />
                        <span>WABAChannels</span>
                    </div>
                </div>
                <div className='w-[100%] mt-2 flex flex-col items-start gap-2'>
                    <button
                        type="button"
                        onClick={() => setopen(true)}
                        className='bg-[#31b07b] flex items-center text-[13px] text-[#fff] font-bold p-2 gap-1 rounded-lg'>
                        <FaWhatsapp />
                        Register New WhatsApp
                    </button>
                    <button
                        type="button"
                        onClick={() => setEmbedSignup(true)}
                        className='bg-[#316bb0] flex items-center text-[13px] text-[#fff] font-bold px-3 py-2 gap-1 rounded-lg'>
                        <FaWhatsapp />
                        WhatsApp Embedded Signup
                    </button>
                </div>
                <table className="w-full overflow-hidden border-[1px] border-[#dee2e6] mt-2 hidden">
                    <thead>
                        <tr className="text-left text-sm font-semibold text-gray-700">
                            {[
                                "WABA Number", "PhoneNumber Id", "WABA BusinessId", "Messaging Limit",
                                "Quality Rating", "Default", "Display Name", "ConfigureDate", "Webhook Url", "Actions"
                            ].map((col, i) => (
                                <th key={col} className="p-2 cursor-pointer border-[1px] border-[#dee2e6] ">
                                    <div className="flex justify-between items-center gap-2">
                                        <span className='text-[11px] text-[#576071] dark:text-[#fff]'>{col}</span>
                                        <button type="button" className="text-gray-500 hover:text-black">
                                            <TbArrowsSort />
                                        </button>
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        <tr className="text-center text-gray-500 bg-[#f6f9fc] dark:bg-[#121519]">
                            {(data || []).map((item, index) => (
                                <td key={index} className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                    {item}
                                </td>
                            ))}
                            <td className="p-1 text-[11px] border-[1px] border-[#dee2e6]">
                                <div className="flex justify-center items-center cursor-pointer">
                                    <HiDotsVertical className="text-[16px] text-gray-600 dark:text-white hover:text-black dark:hover:text-gray-300 transition" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
               
                {/* WhatsApp Embedded Signup Modal, opens real flow in new tab */}
                {embedSignup && (
                    <WhatsappEmbeddedSignupModal onClose={() => setEmbedSignup(false)} />
                )}
            </div>
        </>
    );
}

export default Test;
